import styled from 'styled-components'

const ContentStyle = {}

ContentStyle.Content = styled.div`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || 'calc(100vh - 50px)'};
  padding: ${({ top }) => top || '1rem'} 0.5rem 1.5rem 0.5rem;
  gap: ${({ gap }) => gap || '1rem'};
  display: flex;
  flex-flow: wrap;
  flex-direction: ${({ direction }) => direction || 'column'};
  justify-content: ${({ center }) => center || 'flex-start'};
  align-items: ${({ align }) => align || 'center'};
  margin-bottom: ${({ bottom }) => bottom || '0px'};
  overflow: ${({ overflow }) => overflow || 'hidden'};
  background: ${props => props.theme.colors.background.primary};
  transition: background 0.3s ease;
`

ContentStyle.ContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  padding: 0rem 1rem 0rem 1rem;
  position: relative;
  z-index: 1;
`

ContentStyle.PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: auto;
`

ContentStyle.Table = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.scrollbar.track};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.scrollbar.thumb};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.scrollbar.thumbHover};
  }
`

ContentStyle.Search = styled.input`
  width: ${({ width }) => width || '300px'};
  height: 40px;
  border-radius: ${props => props.theme.radius.input};
  border: 1px solid ${props => props.theme.colors.border.medium};
  background: ${props => props.theme.colors.background.primary};
  color: ${props => props.theme.colors.text.primary};
  padding: 0 1rem 0 2.5rem;
  font-size: ${props => props.theme.typography.fontSize.input};
  font-family: ${props => props.theme.typography.fontFamily};
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px ${props => props.theme.colors.shadow.light};
  position: relative;

  &::before {
    content: '🔍';
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1rem;
  }

  &:hover {
    border-color: ${props => props.theme.colors.text.tertiary};
    background: ${props => props.theme.colors.background.hover};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.border.focus};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.shadow.focus};
  }

  &::placeholder {
    color: ${props => props.theme.colors.text.muted};
  }
`

ContentStyle.PageNumberContainer = styled.div`
  min-width: 32px;
  height: 32px;
  font-weight: 500;
  font-size: ${props => props.theme.typography.fontSize.label};
  font-family: ${props => props.theme.typography.fontFamily};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: ${props => props.theme.colors.background.primary};
  color: ${props => props.theme.colors.text.secondary};
  border: 1px solid ${props => props.theme.colors.border.medium};
  user-select: none;
  transition: all 0.3s ease;
`

ContentStyle.PaginationSelect = styled.select`
  height: 32px;
  padding: 0 0.5rem;
  border: 1px solid ${props => props.theme.colors.border.medium};
  border-radius: 4px;
  background: ${props => props.theme.colors.background.primary};
  font-size: ${props => props.theme.typography.fontSize.label};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 500;
  color: ${props => props.theme.colors.text.secondary};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${props => props.theme.colors.text.tertiary};
    background: ${props => props.theme.colors.background.hover};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.border.focus};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.shadow.focus};
  }
`

ContentStyle.Row = styled.div`
  display: flex;
  // align-items: center;
  flex-flow: ${({ wrap }) => wrap || 'row wrap'};
  justify-content: ${({ center }) => center || 'space-between'};
  width: ${({ width }) => width || '100%'};

  gap: ${({ gap }) => gap || '0.1rem'}; // Gap ridotto
  align-items: ${({ align }) => align || 'flex-start'}; // Allineamento in alto
`

ContentStyle.RowItem = styled.div`
  width: ${({ width }) => width || '45%'};
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  align-items: ${({ align }) => align || 'center'};
  justify-content: ${({ justify }) => justify || 'center'};
  gap: ${({ gap }) => gap || '0px'};
`

ContentStyle.Box = styled.div`
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  background: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.radius.input};
  border: 1px solid ${props => props.theme.colors.border.medium};
  box-shadow: 0 1px 2px ${props => props.theme.colors.shadow.light};
  transition: all 0.3s ease;
`

ContentStyle.Label = styled.label`
  font-size: ${props => props.theme.typography.fontSize.label};
  font-weight: ${props => props.theme.typography.fontWeight.label};
  font-family: ${props => props.theme.typography.fontFamily};
  color: ${props => props.theme.colors.text.secondary};
  display: block;
  margin-bottom: 0.25rem;
  min-width: ${({ minwidth }) => minwidth || '90px'};
  transition: color 0.3s ease;
`

ContentStyle.Text = styled.input`
  width: ${({ width }) => width || '100%'};
  height: 40px;
  border: 1px solid ${props => props.theme.colors.border.medium};
  border-radius: ${props => props.theme.radius.input};
  background: ${props => props.theme.colors.background.primary};
  color: ${props => props.theme.colors.text.primary};
  font-size: ${props => props.theme.typography.fontSize.input};
  font-family: ${props => props.theme.typography.fontFamily};
  transition: all 0.2s ease;
  padding: 0 0.75rem;

  &:hover {
    border-color: ${props => props.theme.colors.text.tertiary};
    background: ${props => props.theme.colors.background.hover};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.border.focus};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.shadow.focus};
  }

  &::placeholder {
    color: ${props => props.theme.colors.text.muted};
  }
`

ContentStyle.Select = styled.select`
  width: ${({ width }) => width || '100%'};
  min-width: ${({ minWidth }) => minWidth || '200px'};
  height: 40px;
  padding: 0 0.75rem;
  border: 1px solid ${props => props.theme.colors.border.medium};
  border-radius: ${props => props.theme.radius.input};
  background: ${props => props.theme.colors.background.primary};
  color: ${props => props.theme.colors.text.primary};
  font-size: ${props => props.theme.typography.fontSize.input};
  font-family: ${props => props.theme.typography.fontFamily};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${props => props.theme.colors.text.tertiary};
    background: ${props => props.theme.colors.background.hover};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.border.focus};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.shadow.focus};
  }
`

ContentStyle.Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  font-family: ${props => props.theme.typography.fontFamily};
  color: ${props => props.theme.colors.text.primary};
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
  transition: color 0.3s ease;
`

ContentStyle.SalutoContainer = styled.div`
  background: ${props => props.theme.colors.background.primary};
  padding: 0.75rem 1.25rem;
  border-radius: ${props => props.theme.radius.input};
  border: 1px solid ${props => props.theme.colors.border.medium};
  box-shadow: 0 1px 2px ${props => props.theme.colors.shadow.light};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-family: ${props => props.theme.typography.fontFamily};
  transition: all 0.3s ease;

  & > div:first-child {
    font-size: 0.875rem;
    color: ${props => props.theme.colors.text.secondary};

    b {
      color: ${props => props.theme.colors.text.primary};
      font-weight: 600;
    }
  }

  & > div:last-child {
    font-size: 0.75rem;
    color: ${props => props.theme.colors.text.tertiary};
  }
`

ContentStyle.EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 3rem;
  text-align: center;

  i {
    font-size: 18px;
    color: ${props => props.theme.colors.text.tertiary};
    font-style: normal;
  }

  svg {
    font-size: 64px;
    color: ${props => props.theme.colors.border.medium};
    margin-bottom: 1rem;
  }
`

ContentStyle.Form = styled.div`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
  display: flex;
  flex-direction: ${({ flexdirection }) => flexdirection || 'column'};
  justify-content: ${({ justify }) => justify || 'space-around'};
`

ContentStyle.FormColumn = styled.div`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ gap }) => gap || '1rem'}; // Default gap più stretto
  justify-content: ${({ justify }) => justify || 'flex-start'}; // Allineamento in alto
`

ContentStyle.FormRow = styled.div`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height};
  display: flex;
  flex-flow: row wrap;
  justify-content: ${({ justify }) => justify || 'space-around'};
  align-items: center;
  gap: ${({ gap }) => gap || '0px'};
  padding-left: ${({ paddingleft }) => paddingleft || '0'};
`

ContentStyle.Textarea = styled.textarea`
  width: ${({ width }) => width || '100%'};
  border: 1px solid ${props => props.theme.colors.border.medium};
  border-radius: ${props => props.theme.radius.input};
  background: ${props => props.theme.colors.background.primary};
  color: ${props => props.theme.colors.text.primary};
  font-size: ${props => props.theme.typography.fontSize.input};
  font-weight: 400;
  resize: vertical;
  min-height: ${({ minheight }) => minheight || '100px'};
  padding: 0.75rem;
  transition: all 0.2s ease;
  font-family: ${props => props.theme.typography.fontFamily};
  line-height: 1.5;
  box-shadow: 0 1px 2px ${props => props.theme.colors.shadow.light};

  &::placeholder {
    color: ${props => props.theme.colors.text.muted};
    font-style: normal;
  }

  &:hover {
    border-color: ${props => props.theme.colors.text.tertiary};
    background: ${props => props.theme.colors.background.hover};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.border.focus};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.shadow.focus};
  }

  /* Scrollbar personalizzata */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.scrollbar.track};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.scrollbar.thumb};
    border-radius: 4px;
    background-clip: content-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.scrollbar.thumbHover};
    background-clip: content-box;
  }

  /* Animazione di resize */
  &:active {
    cursor: ns-resize;
  }
`

ContentStyle.InputAllPage = styled.div`
  width: 95%;
  height: 95vh;
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 25px;
  gap: 25px;
`

ContentStyle.Position = styled.div`
  position: relative;
`

ContentStyle.SelectionBox = styled.div`
  border: 1px solid ${props => props.theme.colors.border.medium};
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  background: ${props => props.theme.colors.background.primary};
  color: ${props => props.theme.colors.text.primary};
  transition: all 0.2s ease;

  &:hover {
    border-color: ${props => props.theme.colors.border.strong};
    background: ${props => props.theme.colors.background.hover};
  }
`

ContentStyle.SelectionList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 100;
  background: ${props => props.theme.colors.background.primary};
  border: 1px solid ${props => props.theme.colors.border.medium};
  border-radius: 4px;
  margin-top: 4px;
  width: 100%;
  box-shadow: 0 4px 12px ${props => props.theme.colors.shadow.medium};
`

ContentStyle.TextVariabili = styled.input`
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`

ContentStyle.NumericInput = styled.input`
  width: ${({ width }) => width || '120px'};
  min-width: ${({ minWidth }) => minWidth || '100px'};
  height: 40px;
  padding: 8px 12px;
  background: ${props => props.theme.colors.background.primary};
  border: 2px solid ${props => props.theme.colors.border.medium};
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  text-align: ${({ align }) => align || 'center'};
  transition: all 0.2s ease;
  color: ${props => props.theme.colors.text.primary};

  &:hover {
    border-color: ${props => props.theme.colors.border.strong};
    background: ${props => props.theme.colors.background.hover};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.border.focus};
    background: ${props => props.theme.colors.background.primary};
    box-shadow: 0 0 0 3px ${props => props.theme.colors.shadow.focus};
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }

  &[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`

ContentStyle.BoxImmagine = styled.img`
  max-width: 256px;
  width: ${({ width }) => width || 'auto'};
  height: auto;
  object-fit: cover;
  padding: 50px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 5px #ABABAB;

  &:hover {
    cursor: ${({ cursor }) => cursor || 'default'};
    transform: scale(1.1);
    transition: transform 0.2s ease;
  }
`

ContentStyle.SwitchContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
`

ContentStyle.HiddenCheckbox = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`

ContentStyle.Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ccc;

  &:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background: white;
  }

  ${ContentStyle.HiddenCheckbox}:checked + & {
    background-color: #2196F3;
  }

  ${ContentStyle.HiddenCheckbox}:checked + &:before {
    transform: translateX(26px);
  }
`

ContentStyle.RoundSlider = styled(ContentStyle.Slider)`
  border-radius: 34px;

  &:before {
    border-radius: 50%;
  }
`

ContentStyle.Calendario = styled.input`
  padding: 10px;
  border-radius: 15px;
  font-size: 24px;
  outline: none;

  &:hover {
    cursor: pointer;
    border: 2px solid #0066ff;
  }
`

export default ContentStyle
